// extracted by mini-css-extract-plugin
module.exports = {"RedesSociales":"RedesSociales_RedesSociales__3H7xB"};